// react context holding client and application ids
import { App } from '../app';
import { createContext, PropsWithChildren } from 'react';
import { useLocalStorage } from 'hooks/useLocalStorage';

type TestingContextValueData = {
  clientID?: string;
  applicationID?: string;
};

export type TestingContextValue = {
  colaUrl: string;
  data: TestingContextValueData;
  setTestingData: (data: React.SetStateAction<TestingContextValueData>) => void;
};

const defaultContext: TestingContextValue = {
  colaUrl: '',
  data: {
    clientID: undefined,
    applicationID: undefined,
  },
  setTestingData: (data) => {
    // eslint-disable-next-line no-console
    console.log('TestingContext is not Provided');
  },
};

export const TestingContext = createContext(defaultContext);

export const LOCAL_STORAGE_KEY_TESTING_DATA = 'testing-data';

export const TestingContextProvider: React.FC<
  PropsWithChildren & {
    app: App<any, any>;
    defaultData?: TestingContextValueData;
  }
> = ({ children, app, defaultData }) => {
  const [{ clientID, applicationID }, setTestingData] =
    useLocalStorage<TestingContextValueData>(
      LOCAL_STORAGE_KEY_TESTING_DATA,
      defaultData || defaultContext.data,
    );

  return (
    <TestingContext.Provider
      value={{
        colaUrl: app.colaUrl,
        data: { clientID, applicationID },
        setTestingData:
          process.env.REACT_APP_ENV !== 'production'
            ? setTestingData
            : () => {},
      }}
    >
      {children}
    </TestingContext.Provider>
  );
};
